<template>
  <!-- postpone parsing until the components get added -->
  <div class="chi-simple-demos-wrapper" v-pre>
    <div class="chi-simple-demos-header">
      <div data-safe-id="chi_chi_simple_demos_summary" data-properties="{
        'classes': ['chi-simple-demos-summary'],
        'style': {},
        'hint': '',
        'shared': true,
        'value': 'No Patient Selected'
      }" :class="components.chi_chi_simple_demos_summary.classes" :style="components.chi_chi_simple_demos_summary.style" :title="components.chi_chi_simple_demos_summary.hint" :value="components.chi_chi_simple_demos_summary.value" :id="'chi-simple-demos-summary'" autocomplete="off" readonly ref="chi-simple-demos-summary" role="readonlyfield" tabindex="-1" v-html="components.chi_chi_simple_demos_summary.value"></div>
    </div>
  </div>
</template>

<style lang="scss">
@import "../scss/_variables.scss";

.k-window-titlebar>.chi-simple-demos-wrapper {
  display: block;
}
.k-window-titlebar.no-top-menu.no-jump-out .chi-simple-demos-wrapper {
  left: 0;
}
.k-window-titlebar.no-top-menu .chi-simple-demos-wrapper,
.k-window-titlebar.no-jump-out .chi-simple-demos-wrapper {
  left: 4.5rem;
}
.chi-simple-demos-wrapper {
  background: transparent;
  display: none;
  height: 2.2857rem;
  left: 9rem;
  overflow: hidden;
  position: absolute;
  text-align: left;
  top: 0;
  .chi-simple-demos-header {
    background: $navigation;
    color: $secondary;
    display: inline-block;
    height: 2.2857rem;
    padding: 0 0.57143rem 0 0.57143rem;
    position: relative;
    width: auto;
    z-index: 10000;
    .chi-simple-demos-summary {
      float: left;
      padding: 0.5rem 0 0.5rem 0;
      width: auto;
    }
  }
}
</style>

<script>
import $ from 'jquery';
import Form from '../js/form.js';

export default {
  name: 'simple-demos',
  components: {},
  inject: ['components'],
  mounted: function () {
    console.debug('simple-demos-mounted:', this);
    setImmediate(function (self) {
      var components = self.$root.$options.api.vm.components;
      if (components && components.chi_chi_simple_demos_summary) {
        $(self.$el).remove();
        return console.debug('skipping simple demos within tab');
      }
      var element = $(self.$el);
      var titlebar = element.closest('.k-window').find('.k-window-titlebar');
      Form.activate_content(element, {
        inject: ['components'],
        name: 'DemosContent',
        parent: self.$root.$options.api.vm
      }, true);
      setImmediate(function () {
        var element = $('.chi-simple-demos-wrapper').last();
        element.insertAfter(titlebar.find('.k-window-title'));
      });
    }, this);
  }
};
</script>
